import React, { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';
import { Grid, Typography, useTheme } from '@mui/material';
import { toSentenceCase } from '@npi/buddy-utils';
import { PartnerOffers } from 'types/graphql';

import { GET_PARTNER } from 'src/graphql/queries/partners.query';
import { TransactionPricingOffer } from 'src/types/AddPartner/pricingInfoStep4';

import { SectionHeader } from './components/SectionHeader';

// TODO: clean up this export type
export type addPartnerSummaryProps = {
    formSummaryData?: {
        assignedOffers: PartnerOffers[];
        assignedTransactionOffers: TransactionPricingOffer[];
        partnerType: string;
        partnerId?: number;
        country: string;
    };
};

export const PartnerType: React.FC<addPartnerSummaryProps> = ({ formSummaryData }) => {
    const [topLevelPartner, setTopLevelPartner] = useState('');
    const [partner] = useLazyQuery(GET_PARTNER);

    const theme = useTheme();

    const getPartner = async () => {
        const { data } = await partner({
            variables: {
                id: formSummaryData?.partnerId,
            },
        });

        setTopLevelPartner(toSentenceCase(data?.partner?.business?.legalName || ''));
    };

    useEffect(() => {
        if (formSummaryData?.partnerId) {
            getPartner();
        }
    }, []);

    return (
        <Grid
            item
            xs={12}
            sx={{ padding: '32px 24px' }}
            container
            data-testid="partner-type-container"
        >
            <SectionHeader title="Partner Type" data-testid="partner-type-header" />

            <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                    color={theme.palette.dark.main}
                    data-testid="partner-type-label"
                >
                    Partner Type
                </Typography>
                <Typography
                    sx={{ fontSize: '20px', fontWeight: 400 }}
                    color="#8E8E8D"
                    data-testid="partner-type-value"
                >
                    {formSummaryData?.partnerType
                        ? toSentenceCase(formSummaryData?.partnerType || '')
                        : ''}
                </Typography>
            </Grid>

            {formSummaryData?.partnerType === 'PARTNER_OF_PARTNER' ? (
                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                        }}
                        color={theme.palette.dark.main}
                        data-testid="parent-partner-label"
                    >
                        Partner of Partner
                    </Typography>

                    <Typography
                        sx={{ fontSize: '20px', fontWeight: 400 }}
                        color="#8E8E8D"
                        data-testid="parent-partner-value"
                    >
                        {topLevelPartner || ''}
                    </Typography>
                </Grid>
            ) : null}
            <Grid
                item
                lg={6}
                xs={12}
                display="flex"
                flexDirection="column"
                gap="24px"
                mt={formSummaryData?.partnerType === 'PARTNER_OF_PARTNER' ? '30px' : '0px'}
                data-testid="country-container"
            >
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                    }}
                    color={theme.palette.dark.main}
                    data-testid="country-label"
                >
                    Country
                </Typography>
                <Typography
                    sx={{ fontSize: '20px', fontWeight: 400 }}
                    color="#8E8E8D"
                    data-testid="country-value"
                >
                    {formSummaryData?.country ?? ''}
                </Typography>
            </Grid>
        </Grid>
    );
};
